import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.scss';
import { useTranslation } from 'react-i18next';
import LeaderIcon from 'images/icons/leader.svg';
import OrdersIcon from 'images/icons/orders.svg';
import CommunicationIcon from 'images/icons/communication.svg';
import FabrickIcon from 'images/icons/components/icn-type-fabrick-white.svg';
import OrganizationIcon from 'images/icons/icn-organization.svg';
import LandingPageNavbar from '../../components/LandingPageNavbar';
const LandingPage = () => {
    const { t } = useTranslation('common');
    return (React.createElement(React.Fragment, null,
        React.createElement(LandingPageNavbar, null),
        React.createElement("div", { className: "LandingPage" },
            React.createElement("ul", null, [
                {
                    label: 'specifications',
                    subviewPath: 'specifications',
                    icon: React.createElement(LeaderIcon, null),
                    enabled: true,
                },
                {
                    label: 'orders',
                    subviewPath: 'orders',
                    icon: React.createElement(OrdersIcon, null),
                    enabled: true,
                },
                {
                    label: 'warehouse_releases',
                    subviewPath: 'warehouse-releases',
                    icon: React.createElement(CommunicationIcon, null),
                    enabled: true,
                },
                {
                    label: 'components_library',
                    subviewPath: 'organization/',
                    icon: React.createElement(FabrickIcon, null),
                    enabled: true,
                },
                {
                    label: 'administration',
                    subviewPath: '/specification-parameters/',
                    icon: React.createElement(OrganizationIcon, null),
                    enabled: true,
                },
            ].map((element) => (React.createElement("li", { key: element.label },
                React.createElement(Link, { to: element.subviewPath, className: `${element.enabled ? '' : 'disabled'}` },
                    React.createElement("div", { className: "image" }, element.icon),
                    React.createElement("h3", null, t(element.label))))))))));
};
export default LandingPage;
